import MinusIconPath from "@ingka/ssr-icon/paths/minus";

export default MinusIconPath;
